import { AddPhotoAlternateOutlined, CancelOutlined, ClassOutlined, CreateOutlined, Event, RotateLeft } from "@mui/icons-material";
import { Divider, ListItemButton, ListItemIcon, Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { ManufacturerCategory, useGetV4ManufacturerByRouteManufacturerIdAccountQuery } from "randmar-api-client";
import ManufacturerContext from "../../contexts/ManufacturerContext";
import DeleteCategoryWrapper from "./DeleteCategoryWrapper";
import EditCategoryImageWrapper from "./EditCategoryImageWrapper";
import EditCategoryWrapper from "./EditCategoryWrapper";

interface IProps {
  category: ManufacturerCategory;
}

const intRegEx = new RegExp("^([0-9]+)?$|^$");

const CategoryActions: React.FC<IProps> = ({ category }) => {
  const { applicationId } = useContext(ManufacturerContext);
  const { data: manufacturer } = useGetV4ManufacturerByRouteManufacturerIdAccountQuery({ routeManufacturerId: applicationId });

  return (
    <Stack sx={{ mx: 1, my: 2 }} maxWidth={250}>
      <Typography sx={{ ml: 1, fontSize: "0.9rem", fontWeight: 500 }} color="primary">
        Edit {category.CategoryName}
      </Typography>
      <EditCategoryWrapper
        informationName="CategoryName"
        informationCurrentValue={category.CategoryName ?? undefined}
        validateFonction={(s: string) => s !== ""}
        label={"Category Name"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <ListItemButton>
          <ListItemIcon>
            <CreateOutlined fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" sx={{ ml: -2 }}>Name</Typography>
        </ListItemButton>
      </EditCategoryWrapper>
      <EditCategoryWrapper
        informationName="Niche"
        informationCurrentValue={category.Niche ?? undefined}
        validateFonction={(s: string) => s !== ""}
        label={"Category Niche"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <ListItemButton>
          <ListItemIcon>
            <ClassOutlined fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" sx={{ ml: -2 }}>Niche</Typography>
        </ListItemButton>
      </EditCategoryWrapper>
      <EditCategoryWrapper
        informationName="WeeksOfStocking"
        informationCurrentValue={String(category.WeeksOfStocking ?? manufacturer?.DefaultWeeksOfStocking ?? "")}
        validateFonction={intRegEx.test.bind(intRegEx)}
        label={"Weeks Of Stocking"}
        categoryCode={category.CategoryCode || ""}
        isFloatInput={false}
      >
        <ListItemButton>
          <ListItemIcon>
            <Event fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" sx={{ ml: -2 }}>Weeks of Stocking</Typography>
        </ListItemButton>
      </EditCategoryWrapper>

      <Divider sx={{ my: 1 }} />

      <Typography sx={{ ml: 1, fontSize: "0.9rem", fontWeight: 500 }} color="primary">
        Utilities
      </Typography>
      {
        category.Products?.length === 0 &&
        <DeleteCategoryWrapper
          category={category}
          buttonTitle="Reset to Default Settings"
          text="These are your default settings"
        >
          <ListItemButton>
            <ListItemIcon>
              <RotateLeft fontSize="small" />
            </ListItemIcon>
            <Typography variant="body2" sx={{ ml: -2 }}>Reset to Default</Typography>
          </ListItemButton>
        </DeleteCategoryWrapper>
      }

      <EditCategoryImageWrapper  categoryCode={category.CategoryCode || ""}>
        <ListItemButton>
          <ListItemIcon>
            <AddPhotoAlternateOutlined fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" sx={{ ml: -2 }}>Upload Category Image</Typography>
        </ListItemButton>
      </EditCategoryImageWrapper>
      {
        (!category.Products || category.Products.length <= 0) &&
        <DeleteCategoryWrapper
          category={category}
          buttonTitle="Delete Category"
          disabled={!!category.Products && category.Products.length > 0}
          text="Delete forever?"
        >
          <ListItemButton>
            <ListItemIcon>
              <CancelOutlined fontSize="small" />
            </ListItemIcon>
            <Typography variant="body2" sx={{ ml: -2 }}>Delete Category</Typography>
          </ListItemButton>
        </DeleteCategoryWrapper>
      }
    </Stack>
  )
};

export default CategoryActions;
